module.exports = __webpack_public_path__ + "img/icon-borrow-btc-usdt.5dacf58d.svg";